var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteExpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 323,
    viewBox: "0 0 360 323",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_3088_177585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.44 161.5C358.453 196.639 346.993 230.823 325.801 258.866C304.609 286.909 274.84 307.279 241.011 316.887C233.977 318.884 226.814 320.393 219.572 321.405C212.029 322.467 204.42 323 196.803 323C164.834 323 133.583 313.528 107.002 295.782C80.4204 278.037 59.703 252.814 47.469 223.303C35.2351 193.793 32.0341 161.321 38.2709 129.993C44.5077 98.665 59.9022 69.8885 82.5076 47.3023C105.113 24.7161 133.914 9.33476 165.269 3.10325C196.623 -3.12826 229.123 0.0699757 258.658 12.2935C288.194 24.5171 313.438 45.2169 331.199 71.7755C348.96 98.334 358.44 129.558 358.44 161.5Z",
    fill: "#F5F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.925 260.81C163.925 284.552 142.787 303.776 116.702 303.776C90.6162 303.776 69.4961 284.552 69.4961 260.81C69.4961 237.067 90.634 217.932 116.702 217.932C124.043 217.908 131.303 219.474 137.981 222.521C144.66 225.568 150.598 229.226 156.796 238.166C161.409 244.82 163.895 252.715 163.925 260.81Z",
    fill: "#EF7ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.277 271.087L119.114 270.821C119.882 270.742 120.594 270.382 121.111 269.809C121.629 269.236 121.915 268.492 121.916 267.721V235.385C121.917 234.624 121.641 233.889 121.138 233.318C120.635 232.747 119.94 232.38 119.185 232.284C115.223 231.804 111.206 232.099 107.357 233.153C106.573 233.365 105.903 233.875 105.49 234.573C105.076 235.271 104.95 236.102 105.14 236.891L112.961 268.784C113.15 269.498 113.588 270.122 114.195 270.543C114.803 270.965 115.54 271.158 116.277 271.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.777 286.094C122.126 286.094 124.841 283.381 124.841 280.034C124.841 276.688 122.126 273.975 118.777 273.975C115.427 273.975 112.712 276.688 112.712 280.034C112.712 283.381 115.427 286.094 118.777 286.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.603 49.292L232.038 39.6179C229.813 39.4029 227.567 39.6286 225.429 40.2819C223.29 40.9352 221.302 42.0033 219.578 43.4252C217.853 44.8471 216.426 46.5948 215.378 48.5683C214.331 50.5418 213.683 52.7023 213.472 54.9263L207.797 113.821C207.372 118.297 208.743 122.758 211.61 126.224L242.82 164.052C242.944 164.205 243.003 164.4 242.983 164.596C242.963 164.792 242.866 164.972 242.714 165.097L204.853 196.281C203.125 197.7 201.694 199.446 200.644 201.419C199.594 203.393 198.945 205.555 198.735 207.78L193.061 266.657C192.838 268.883 193.058 271.132 193.707 273.273C194.356 275.415 195.423 277.407 196.845 279.135C198.267 280.864 200.016 282.295 201.993 283.346C203.97 284.397 206.135 285.048 208.365 285.261L308.929 294.935C311.154 295.152 313.399 294.929 315.537 294.278C317.675 293.627 319.664 292.56 321.388 291.14C323.113 289.719 324.541 287.973 325.589 286C326.637 284.027 327.285 281.868 327.496 279.644L333.17 220.767C333.598 216.294 332.234 211.834 329.375 208.365L298.147 170.448C298.027 170.293 297.971 170.099 297.991 169.904C298.011 169.709 298.105 169.53 298.254 169.403L336.114 138.201C337.842 136.788 339.273 135.048 340.326 133.081C341.379 131.114 342.033 128.958 342.25 126.738L347.924 67.8428C348.139 65.6192 347.914 63.375 347.26 61.2387C346.606 59.1024 345.537 57.1159 344.114 55.3928C342.691 53.6698 340.941 52.244 338.966 51.1972C336.991 50.1503 334.829 49.5029 332.603 49.292Z",
    fill: "url(#paint0_linear_3088_177585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.87 184.074C282.382 185.385 303.201 207.851 310.791 216.516C311.704 217.562 312.393 218.784 312.813 220.107C313.234 221.429 313.379 222.824 313.238 224.205L311.465 243.695C311.409 244.261 311.243 244.81 310.975 245.311C310.707 245.812 310.342 246.256 309.903 246.616C309.463 246.976 308.956 247.247 308.412 247.411C307.868 247.576 307.296 247.632 306.73 247.575L219.838 239.212C219.272 239.159 218.722 238.995 218.219 238.729C217.717 238.463 217.272 238.101 216.91 237.664C216.547 237.226 216.275 236.721 216.108 236.178C215.941 235.635 215.883 235.065 215.936 234.499L217.816 215.009C217.948 213.627 218.36 212.285 219.027 211.066C219.695 209.848 220.604 208.778 221.7 207.922C230.619 200.853 255.357 182.78 268.87 184.074Z",
    fill: "url(#paint1_linear_3088_177585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.137 47.394L209.276 33.265C206.937 33.0399 204.857 34.7525 204.632 37.0902L201.993 64.4796C201.767 66.8173 203.481 68.8949 205.821 69.1199L352.681 83.249C355.021 83.4741 357.1 81.7615 357.326 79.4238L359.965 52.0343C360.19 49.6967 358.476 47.6191 356.137 47.394Z",
    fill: "#DBDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.825 287.106L331.686 301.235C334.025 301.46 336.105 299.748 336.33 297.41L338.969 270.02C339.195 267.683 337.481 265.605 335.141 265.38L188.281 251.251C185.941 251.026 183.862 252.739 183.636 255.076L180.997 282.466C180.771 284.803 182.486 286.881 184.825 287.106Z",
    fill: "#DBDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.632 69.5273L13.954 101.089C9.9284 101.884 7.31061 105.79 8.10696 109.812L27.5953 208.242C28.3917 212.264 32.3006 214.88 36.3261 214.084L196.004 182.523C200.03 181.727 202.647 177.821 201.851 173.799L182.363 75.3694C181.566 71.3472 177.657 68.7317 173.632 69.5273Z",
    fill: "url(#paint2_radial_3088_177585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.459 74.1855L114.645 147.485C112.542 149.823 109.733 151.411 106.645 152.009C103.556 152.607 100.357 152.182 97.5321 150.798C75.6672 139.813 24.986 113.59 10.3916 106.184",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4533 191.957L3.54688 199.664",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6583 173.266L12.8389 178.368",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3088_177585",
    x1: 282.5,
    y1: -58,
    x2: 270.49,
    y2: 295.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3088_177585",
    x1: 271.5,
    y1: 199.5,
    x2: 267.848,
    y2: 256.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951407,
    stopColor: "#8627EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3088_177585",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.5 52.5) rotate(65.0829) scale(225.489 225.306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8627EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3088_177585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 323,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteExpire);
export default __webpack_public_path__ + "static/media/invite-expire.211e056fa57da09c592005ab7128a3c3.svg";
export { ForwardRef as ReactComponent };